<div class="component-container flex flex-col xs:p-[2rem] sm:p-[1rem] md:p-[2.7rem]">
  <div class="w-full flex justify-center mt-[2rem] sm:mt-[0%]">
    <div class="search-section w-full flex flex-col sm:flex-row justify-between items-center">
      <div
        class="sm:w-[70%] w-[95%]">
        <app-text-input
          (handleSuffixClick)="applyButtonClicked()"
          [parentFormGroup]="filterForm"
          [suffixIcon]="'search'"
          controlName="searchText"
          label="Search"
          placeholder="Search"
          type="small"
        ></app-text-input>
      </div>
      <div class="min-w-[2%] search-separator h-[50%]">
      </div>
      <div
        class="filter-apply-button-wrapper w-full sm:flex items-center justify-end sm:w-[25%]">
        <app-primary-button
          (handleClick)="applyButtonClicked()"
          class="w-[95%]"
          type="small">
          Apply
        </app-primary-button>
      </div>
    </div>
  </div>
  <div
    class="table-section"
  >
    <mat-expansion-panel
      [expanded]="expandPanel"
      class="mat-elevation-z0 expansion-panel w-full"
    >
      <mat-expansion-panel-header
        class="bg-black-100 expansion-panel-header justify-center"
      >
        <div class="title">
          Respondents
        </div>
      </mat-expansion-panel-header>
      <div class="table-container">
        <table
          [dataSource]="surveyRespondentData"
          class="mat-elevation-z8"
          mat-table
        >
          <ng-container
            [sticky]="true"
            matColumnDef="name"
          >
            <th
              *matHeaderCellDef
              class="w-[18rem]"
              mat-header-cell
            >
              <div class="th-cell">
                Name
              </div>
            </th>
            <td *matCellDef="let eachRow;let index=index"
                mat-cell>
              <div class="td-cell">
                <div class="survey-title text-wrapper">
                  {{ eachRow.name }}
                </div>
              </div>
            </td>
          </ng-container>
          <ng-container
            matColumnDef="clinics"
          >
            <th
              *matHeaderCellDef
              class="w-[15rem]"
              mat-header-cell
            >
              <div class="th-cell survey-title">
                Organizations
              </div>
            </th>
            <td *matCellDef="let eachRow"
                mat-cell>
              <div class="td-cell survey-content survey-title text-wrapper">
                {{ eachRow?.client?.name }}
              </div>
            </td>
          </ng-container>
          <ng-container
            matColumnDef="groups"
          >
            <th
              *matHeaderCellDef
              class="w-[15rem]"
              mat-header-cell
            >
              <div class="th-cell survey-title">
                Groups
              </div>
            </th>
            <td *matCellDef="let eachRow"
                mat-cell>
              <div class="td-cell survey-content survey-title text-wrapper">
                {{ getClinicsAndGroupList(eachRow.groups) }}
              </div>
            </td>
          </ng-container>
          <ng-container
            matColumnDef="dateOfResponding"
          >
            <th
              *matHeaderCellDef
              class="w-[15rem]"
              mat-header-cell
            >
              <div class="th-cell survey-title">
                Date Of Responding
              </div>
            </th>
            <td *matCellDef="let eachRow"
                mat-cell>
              <div class="td-cell survey-content survey-title">
                <div class="status-open"></div>
                {{ eachRow.respondedOn | date }}
              </div>
            </td>
          </ng-container>
          <ng-container
            matColumnDef="view"
          >
            <th
              *matHeaderCellDef
              class="w-[10rem]"
              mat-header-cell
            >
              <div class="th-cell survey-title">
              </div>
            </th>
            <td *matCellDef="let eachRow"
                mat-cell>
              <div
                class="td-cell clickable survey-content survey-title">
              <span (click)="viewSurveyDetails(eachRow)"
                    *ngIf="eachRow.role !== 1 && eachRow.role > loggedInUserRole">
                View
              </span>
              </div>
            </td>
          </ng-container>
          <tr *matHeaderRowDef="surveyDisplayColumn"
              mat-header-row></tr>
          <tr *matRowDef="let row; columns: surveyDisplayColumn;"
              mat-row></tr>
        </table>
        <div *ngIf="loading"
             [ngClass]="{ 'initial': !dataSource?.data?.length }"
             class="table-loader w-full flex justify-center items-center">
          <mat-spinner/>
        </div>
        <div
          *ngIf="!surveyRespondentData?.length && !loading"
          class="no-data flex flex-col justify-center items-center"
        >
          <div class="text">
            No Data Found
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  </div>

</div>

<div
  class="component-container flex flex-col xs:px-[2rem] sm:px-[1rem] md:px-[2.7rem] mt-[2rem] pending-survey-wrapper">
  <div
    class="table-section"
  >
    <mat-expansion-panel
      [expanded]="expandPanel"
      class="mat-elevation-z0 expansion-panel w-full"
    >
      <mat-expansion-panel-header
        class="bg-black-100 expansion-panel-header justify-center"
      >
        <div class="title">
          Pending
        </div>
      </mat-expansion-panel-header>
      <div class="table-container">
        <table
          [dataSource]="surveyPendingData"
          class="mat-elevation-z8"
          mat-table
        >
          <ng-container
            [sticky]="true"
            matColumnDef="name"
          >
            <th
              *matHeaderCellDef
              class="w-[18rem]"
              mat-header-cell
            >
              <div class="th-cell">
                Name
              </div>
            </th>
            <td *matCellDef="let eachRow;let index=index"
                mat-cell>
              <div class="td-cell">
                <div class="survey-title text-wrapper">
                  {{ eachRow.name }}
                </div>
              </div>
            </td>
          </ng-container>
          <ng-container
            matColumnDef="clinics"
          >
            <th
              *matHeaderCellDef
              class="w-[15rem]"
              mat-header-cell
            >
              <div class="th-cell survey-title">
                Organizations
              </div>
            </th>
            <td *matCellDef="let eachRow"
                mat-cell>
              <div class="td-cell survey-content survey-title text-wrapper">
                {{ eachRow?.client?.name }}
              </div>
            </td>
          </ng-container>
          <ng-container
            matColumnDef="groups"
          >
            <th
              *matHeaderCellDef
              class="w-[15rem]"
              mat-header-cell
            >
              <div class="th-cell survey-title">
                Groups
              </div>
            </th>
            <td *matCellDef="let eachRow"
                mat-cell>
              <div class="td-cell survey-content survey-title text-wrapper">
                {{ getClinicsAndGroupList(eachRow.groups) }}
              </div>
            </td>
          </ng-container>

          <ng-container
            matColumnDef="view"
          >
            <th
              *matHeaderCellDef
              class="w-[10rem]"
              mat-header-cell
            >
              <div class="th-cell survey-title">
                <!--                Status-->
              </div>
            </th>
            <td *matCellDef="let eachRow"
                mat-cell>
              <div
                (click)="status.key !== 3 ? sendReminder(eachRow) : {}"
                [class.clickable]="status.key !== 3"
                class="td-cell survey-content survey-title"
              >
                Send Reminder
              </div>
            </td>
          </ng-container>
          <tr *matHeaderRowDef="pendingDisplayColumns"
              mat-header-row></tr>
          <tr *matRowDef="let row; columns: pendingDisplayColumns;"
              mat-row></tr>
        </table>
        <div *ngIf="loading"
             [ngClass]="{ 'initial': !dataSource?.data?.length }"
             class="table-loader w-full flex justify-center items-center">
          <mat-spinner/>
        </div>
        <div
          *ngIf="!surveyPendingData?.length && !loading"
          class="no-data flex flex-col justify-center items-center"
        >
          <div class="text">
            No Data Found
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  </div>

</div>
